// extracted by mini-css-extract-plugin
export default {"social-media":"SocialMedia_social-media__SHdK4"};